import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Box, Typography } from "@mui/material";

const data = [{ name: "Group A", value: 29 }];

interface EmployeePiChartProps {
  employee?: any;
}

const EmployeePiChart = ({ employee }: EmployeePiChartProps) => {
  return (
    <Box sx={{ width: 120, height: 120, position: "relative" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <defs>
            <linearGradient
              id="gradientColor"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor="#005bea" />
              <stop offset="100%" stopColor="#00c6fb" />
            </linearGradient>
          </defs>
            <Pie
                data={data}
                innerRadius={50}
                outerRadius={60}
                fill="url(#gradientColor)"
                paddingAngle={5}
                dataKey="value"
                startAngle={60}
                endAngle={-280}
                cornerRadius={10}
            >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={`url(#gradientColor)`} stroke={"none"} />
                ))}
            </Pie>
        </PieChart>
      </ResponsiveContainer>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h4" component="div" style={{fontSize: '24px', fontWeight: 'bold' , color: '#fff'}}>
          {employee?.statuses?.Pending?.count || 0}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmployeePiChart;
